export const getCSRFMiddlewareToken = node => {
    const CSRFMiddlewareTokenNode = node.getElementsByTagName('input')[0];

    return CSRFMiddlewareTokenNode ? CSRFMiddlewareTokenNode.value : null;
};

export default getCSRFMiddlewareToken;



// WEBPACK FOOTER //
// ./scripts/utils/csrf.js